import type { FabricData } from '../types';

const API_BASE = '/api';

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const errorText = await response.text().catch(() => 'Unknown error');
    throw new Error(
      `API request failed: ${response.status} ${response.statusText} - ${errorText}`
    );
  }
  return response.json() as Promise<T>;
}

/**
 * Fetch the current status of all mirrored databases and their tables.
 */
export async function fetchStatus(): Promise<FabricData> {
  const response = await fetch(`${API_BASE}/status`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<FabricData>(response);
}

/**
 * Trigger a refresh of all mirrored databases.
 */
export async function refreshAll(): Promise<FabricData> {
  const response = await fetch(`${API_BASE}/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<FabricData>(response);
}

/**
 * Trigger a refresh of a specific mirrored database by its ID.
 */
export async function refreshDatabase(databaseId: string): Promise<FabricData> {
  const response = await fetch(
    `${API_BASE}/refresh?databaseId=${encodeURIComponent(databaseId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }
  );
  return handleResponse<FabricData>(response);
}
